import { SxProps, Theme } from '@mui/material';

export const nbsp = String.fromCharCode(160);

// Можно хранить в константе, так как не зависят от размера экрана
export const borderRadiusValues = {
  XSmall: 0.25,
  small: 0.5,
  medium: 1,
  large: 1.5,
  XLarge: 3,
  square: 12,
  round: 50,
};
export const DEFAULT_ELEVATION = 5;

export const noValue = '—';

export const zIndexes = {
  header: 10,
};

export const pxToRem = (val: number) => {
  return val / 16;
};

export const sxMixins = {
  getScrollbarStyle: ({
    scrollableBg = '#33333333',
    scrollColor = '#33333326',
  }: {
    scrollableBg?: string;
    scrollColor?: string;
  }) => {
    return {
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: `${scrollColor}`,
        border: `3px solid ${scrollableBg}`,
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '20px',
        backgroundColor: `${scrollColor}`,
      },
      '&': {
        scrollbarWidth: 'thin !important',
        scrollbarColor: `${scrollColor} ${scrollableBg} !important`,
      },
    } as SxProps;
  },
  getMiniScroll: () => {
    return {
      // '&': {
      //   scrollbarWidth: 'thin',
      //   scrollbarColor: theme.palette.primary.main,
      // },
      // '&::-webkit-scrollbar': {
      //   width: '2px',
      // },
      // '&::-webkit-scrollbar-thumb': {
      //   border: 'none',
      //   backgroundColor: theme.palette.primary.main,
      // },

      '::-webkit-scrollbar': {
        width: 10,
      },

      '::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },

      '::-webkit-scrollbar-thumb': {
        background: '#888',
      },

      '::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    };
  },
};
